import api from '../utils/Requester'
import { PLATFORM_CONFIGURATION_SPECIFIC } from '../constants/url'
import { bindParams } from '../utils/Link'

const MB_TO_BYTES = 1024 * 1024

let cachedMaxFileSize = 10 // fallback in MB
let maxFileSizeLoaded = false

export async function loadMaxFileSize(platformId) {
    if (maxFileSizeLoaded) return
    maxFileSizeLoaded = true
    try {
        const translationCode = 'FileMaxSize'
        api
			.get(
				bindParams(PLATFORM_CONFIGURATION_SPECIFIC, platformId, translationCode),
			)
            .then(res => {
                const { data, ok, originalError } = res

                if (originalError && originalError.code === 'ECONNABORTED') return

                if (!ok) return
                if (data) {
                    const parsedValue = parseFloat(data.value)
                    if (!Number.isNaN(parsedValue) && parsedValue > 0) {
                        cachedMaxFileSize = parsedValue
                    }
                }
            })
    } catch (error) {
        console.error('Failed to load max file size:', error)
    }
}

export function getMaxFileSize() {
    return cachedMaxFileSize * MB_TO_BYTES
}

export function getHumanFileSize(lg, fileSize = getMaxFileSize()) {
    if (fileSize === 0) return '0 Bytes'
    const k = 1024
    const dm = 2
    const sizes = lg === 'en' ? ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['Octets', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo']
    const i = Math.floor(Math.log(fileSize) / Math.log(k))
    return parseFloat((fileSize / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}